export default __webpack_public_path__ + "static/media/home-main-article-image.72c36074.png";